import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, vModelText as _vModelText, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fe1fdbf8"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "h-100",
  style: {"overflow-x":"hidden"}
}
const _hoisted_2 = { class: "main-div" }
const _hoisted_3 = { class: "lblTitle" }
const _hoisted_4 = { class: "back-div" }
const _hoisted_5 = {
  key: 0,
  class: "noPDF"
}
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "checkbox-div" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, [
  /*#__PURE__*/_createElementVNode("b", null, "I read the full text")
], -1 /* HOISTED */))
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["Loading"], { isLoading: $setup.isLoading }, null, 8 /* PROPS */, ["isLoading"]),
    _createVNode($setup["Alert"], {
      alertMessage: $setup.alertMessage,
      alertState: $setup.alertState
    }, null, 8 /* PROPS */, ["alertMessage", "alertState"]),
    _createVNode($setup["Navigation"]),
    _createVNode($setup["SalesNoteHeaderNavigation"]),
    _createVNode($setup["SalesNoteLinkNavigation"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, "Sales No. " + _toDisplayString($setup.strSalesNo), 1 /* TEXT */),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          class: "btn btn-primary text-center btn-back",
          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.goBack()))
        }, "Back")
      ], 512 /* NEED_PATCH */), [
        [_vShow, $setup.kdpSalesNoteScreenFlg == 'Confirm']
      ]),
      _createElementVNode("div", {
        class: "pdfInfo",
        style: _normalizeStyle({'--pdfFileHeight': $setup.pdfFileHeight })
      }, [
        ($setup.pdfurl == '')
          ? (_openBlock(), _createElementBlock("label", _hoisted_5, _toDisplayString($setup.i18n.t("alt110")), 1 /* TEXT */))
          : (_openBlock(), _createElementBlock("iframe", {
              key: 1,
              class: "pdfDetails",
              src: $setup.pdfurl
            }, null, 8 /* PROPS */, _hoisted_6))
      ], 4 /* STYLE */),
      _createElementVNode("div", _hoisted_7, [
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          class: "chkCheck",
          onClick: $setup.chkCheckChange,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.chkCheck) = $event))
        }, null, 512 /* NEED_PATCH */), [
          [_vModelCheckbox, $setup.chkCheck]
        ]),
        _hoisted_8
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn btn-primary text-center btn-cancel",
          onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.goCancel()))
        }, "Cancel"),
        _createElementVNode("button", {
          class: "btn btn-primary text-center btn-next",
          onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.goNext())),
          disabled: $setup.btnFlg
        }, "Next", 8 /* PROPS */, _hoisted_9)
      ], 512 /* NEED_PATCH */), [
        [_vShow, $setup.kdpSalesNoteScreenFlg == 'Issuse']
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createElementVNode("button", {
          class: "btn btn-primary text-center btn-cancel",
          onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.goReject())),
          disabled: $setup.btnFlg
        }, "Reject", 8 /* PROPS */, _hoisted_10),
        _createElementVNode("button", {
          class: "btn btn-primary text-center btn-next",
          onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.goApprove())),
          disabled: $setup.btnFlg
        }, _toDisplayString($setup.btnShowText), 9 /* TEXT, PROPS */, _hoisted_11),
        _withDirectives(_createElementVNode("input", {
          class: "txtMessage",
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.txtMessage) = $event)),
          placeholder: "Message : "
        }, null, 512 /* NEED_PATCH */), [
          [_vModelText, $setup.txtMessage]
        ])
      ], 512 /* NEED_PATCH */), [
        [_vShow, $setup.kdpSalesNoteScreenFlg == 'Confirm']
      ])
    ])
  ]))
}